import NextLink from 'next/link';
import type { FC, PropsWithChildren } from 'react';

import type { TLink } from '@/lib/interfaces/elements/link.types';
import cn from '@/lib/packages/cn';
import { linkVariants } from '@/lib/packages/tailwind.variants';

const Link: FC<PropsWithChildren<TLink & Record<string, unknown>>> = ({
  children,
  className,
  id,
  href,
  target,
  type,
  prefetch,
  onClick,
  variant,
  ...rest
}) => {
  if (!href) return null;

  return (
    <NextLink
      id={id ? String(id) : undefined}
      href={href}
      className={cn(linkVariants({ variant }), className)}
      target={target}
      rel={type}
      onClick={onClick}
      {...rest}
    >
      {children}
    </NextLink>
  );
};

export default Link;
